import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Type, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { ElementFormula } from "../../../models/base-info/element-formula.model";
import { ElementProperty } from "../../../models/base-info/element-property.model";
import { Element } from "../../../models/base-info/element.model";
import { FormulaInfo } from "../../../models/base-info/formula.model";
import { EffectBase } from "../../../models/enums/effect-base";
import { ElementGroup } from "../../../models/enums/element-group";
import { ElementKind } from "../../../models/enums/element-kind";
import { ElementFormulaComponent } from "../element-formula/element-formula.component";
import { ElementPropertyFormComponent } from "../element-property-form/element-property-form.component";
@Component({
  selector: "ngx-element-form",
  templateUrl: "./element-form.component.html",
  styleUrls: ["./element-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementFormComponent extends BaseFormComponent<Element> {
  _columns: form_control[] = [];
  public apiName: string = "Element";
  public label: string = "تعریف عوامل";
  RowForSelect: ElementProperty;
  @ViewChild("ElementPropertys") public ElementPropertys: KGridComponent;
  inputEditorform: Type<any>;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
    this.inputEditorform = ElementPropertyFormComponent;
  }
  async ngOnInit() {
    super.ngOnInit();
  }
  setColumnAttribute() {
    this._columns = this.getDetailControlModels("ElementPropertys");
  }
  onChange($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Lookup") && $event.KeyName === "ElementGroupId") {
      this.setValue("ElementGroupCode", $event.data.Code);
      this.setValue("ElementGroupTitle", $event.data.Title);
      this.model.ElementGroupTitle = $event.data.Title;
      this.model.ElementGroupCode = $event.data.Code;
      if ($event.data.Code === ElementGroup.Loan) {
        this.lookupservice
          .getLookupbyCode("HRM", "ElementKind", ElementKind.Computational)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((x) => {
            this.setValue("ElementKindId", x.Id);
            this.formGroup.controls["ElementKindId"].disable();
            this.setValue("ElementKindCode", x.Code);
            this.setValue("ElementKindTitle", x.Title);
            this.model.ElementKindTitle = x.Title;
            this.model.ElementKindCode = x.Code;
            this.model.ElementKindId = x.Id;
          });
      } else this.formGroup.controls["ElementKindId"].enable();
    } else if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Lookup") && $event.KeyName === "ElementKindId") {
      this.setValue("ElementKindCode", $event.data.Code);
      this.setValue("ElementKindTitle", $event.data.Title);
      this.model.ElementKindCode = $event.data.Code;
      this.model.ElementKindTitle = $event.data.Title;
    }
  }
  onDeleteElementProperty($event: ElementProperty) {
    if (
      $event.ElementFormulas.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) &&
      $event.ElementFormulas.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length > 0
    ) {
      this.sts.showDialog("به علت وجود فرمول عامل امکان حذف نیست.", "حذف خصوصیت");
    } else {
      let temp = this.model.ElementPropertys.find(
        (x) => (x.Id && x.Id !== 0 && x.Id === $event.Id) || ($event.TempRowNumber && x.TempRowNumber === $event.TempRowNumber)
      );
      if (temp && temp.State === RowState.New) temp.State = RowState.Detached;
      else temp.State = RowState.Delete;
      if (this.ElementPropertys) this.ElementPropertys.refreshData();
      this.cd.markForCheck();
    }
  }
  onEditElementProperty($event) {
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.getDetailControlModels("ElementPropertys"),
          areaName: this.areaName,
          ElementGroupCode: this.formGroup?.get("ElementGroupCode")?.value,
          ElementKindCode: this.formGroup?.get("ElementKindCode")?.value,
          label: `خصوصیت عامل(${this.model.Title})`,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          (model as ElementProperty).State = RowState.Modify;
          this.model.ElementPropertys.forEach((x) => {
            if ((x.Id && x.Id !== 0 && x.Id === $event.Id) || ($event.TempRowNumber && x.TempRowNumber === $event.TempRowNumber)) {
              this.makeFormula(model as ElementProperty);
              Object.assign(x, model);
              if (this.ElementPropertys) this.ElementPropertys.refreshData();
              this.cd.markForCheck();
            }
          });
        }
      });
  }
  setdefault() {
    this.model.ShowInBillPay = this.model.ShowInBillPay ?? true;
  }
  onCreateElementProperty($event: ElementProperty) {
    if (!this.model.ElementPropertys) this.model.ElementPropertys = [];
    $event = this.model.ElementPropertys.length > 0 ? Object.assign({}, this.model.ElementPropertys[0]) : <ElementProperty>{};
    $event.ElementId = this.model.Id ?? 0;
    $event.Id = 0;
    $event.TempRowNumber = this.model.ElementPropertys.length + 100;
    $event.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    $event.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    $event.EffectYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    $event.EffectMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    $event.State = RowState.New;
    if ($event.ElementFormulas && $event.ElementFormulas.length > 0) $event.ElementFormulas.forEach((x) => (x.Id = 0));
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.getDetailControlModels("ElementPropertys"),
          areaName: this.areaName,
          ElementGroupCode: this.formGroup?.get("ElementGroupCode")?.value,
          ElementKindCode: this.formGroup?.get("ElementKindCode")?.value,
          label: `خصوصیت عامل(${this.model.Title})`,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          if (
            !this.model.ElementPropertys.some(
              (x) => (x.TempRowNumber && x.TempRowNumber === $event.TempRowNumber) || (x.Id && x.Id !== 0 && x.Id === $event.Id)
            )
          ) {
            if (!this.model.ElementPropertys) this.model.ElementPropertys = [];
            this.makeFormula(model as ElementProperty);
            this.model.ElementPropertys.push(model as ElementProperty);
            this.model.ElementPropertys = this.model.ElementPropertys;
            if (this.ElementPropertys) this.ElementPropertys.refreshData();
            this.cd.markForCheck();
          }
        }
      });
  }
  editFormula() {
    if (!this.RowForSelect) {
      this.sts.showDialog("هیچ رکوردی انتخاب نشده است.", "حذف خصوصیت");
      return;
    }
    this.dialogService
      .open(
        ElementFormulaComponent,
        {
          currentrow: this.RowForSelect,
          areaName: this.areaName,
          label: `فرمول عامل(${this.model.Title})`,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          (model as ElementProperty).State = RowState.Modify;
          this.model.ElementPropertys.forEach((x) => {
            if (
              (x.Id && x.Id !== 0 && x.Id === this.RowForSelect.Id) ||
              (this.RowForSelect.TempRowNumber && x.TempRowNumber === this.RowForSelect.TempRowNumber)
            ) {
              Object.assign(x, model);
              if (this.ElementPropertys) this.ElementPropertys.refreshData();
              this.cd.markForCheck();
            }
          });
        }
      });
  }
  beforupdate() {
    if (this.model.ElementPropertys && this.model.ElementPropertys.some((x) => !x.ElementId)) {
      this.model.ElementPropertys.filter((x) => !x.ElementId).forEach((x) => {
        x.ElementId = 0;
      });
    }
    if (this.model.ElementPropertys) {
      this.model.ElementPropertys.forEach((x) => {
        if (x.Id && (!x.ElementFormulas || x.ElementFormulas.length <= 0) && x.State <= RowState.Modify && x.State >= RowState.New)
          this.makeFormula(x as ElementProperty);
      });
    }
  }
  makeFormula(model: ElementProperty) {
    if (model.ElementFormulas && model.ElementFormulas.length > 0) return;
    let PropertyInfo: FormulaInfo[] = [];
    let _elementFormula: ElementFormula = <ElementFormula>{};
    _elementFormula.State = RowState.New;
    //از نوع فرم ورودی
    if (this.model.ElementKindCode === ElementKind.InputForm && this.model.Id) {
      _elementFormula.ElementPropertyId = model.Id;
      _elementFormula.Formula = `MW_${this.model.Id}`;
      model.ElementFormulas = [];
      model.ElementFormulas.push(_elementFormula);
    }
    //از نوع حکمی
    if (this.model.ElementKindCode === ElementKind.EmploymentOrder && this.model.Id) {
      _elementFormula.ElementPropertyId = model.Id;
      if (model.Coefficien && model.Coefficien > 0) {
        if (!model.ProportionalWorkEffect) _elementFormula.Formula = `EMP_${this.model.Id}*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.WithoutBase && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.FixedWork && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}/${model.EffectBaseAmount}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.StandardWork && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}/S_MonthlyStandardWorks*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.CalendarWork && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}/S_MonthlycalendardWorks*${model.Coefficien}`;
      } else {
        if (!model.ProportionalWorkEffect) _elementFormula.Formula = `EMP_${this.model.Id}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.WithoutBase && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.FixedWork && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}/${model.EffectBaseAmount}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.StandardWork && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}/S_MonthlyStandardWorks`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.CalendarWork && model.ProportionalwithElementId)
          _elementFormula.Formula = `EMP_${this.model.Id}*MV_${model.ProportionalwithElementId}/S_MonthlycalendardWorks`;
      }
      PropertyInfo.push({ Title: this.model.Title, key: `EMP_${this.model.Id}`, Formula: `EMP_${this.model.Id}`, items: [] });
      PropertyInfo.push({
        Title: model.ProportionalwithElementTitle,
        key: `MV_${model.ProportionalwithElementId}`,
        Formula: `MV_${model.ProportionalwithElementId}`,
        items: [],
      });
      PropertyInfo.push({ Title: "کارکرد استاندارد", key: `S_MonthlyStandardWorks`, Formula: `S_MonthlyStandardWorks`, items: [] });
      PropertyInfo.push({ Title: "کارکرد تقویمی", key: `S_MonthlycalendardWorks`, Formula: `S_MonthlycalendardWorks`, items: [] });

      model.ElementFormulas = [];
      _elementFormula.PropertyInfo = JSON.stringify(PropertyInfo);
      model.ElementFormulas.push(_elementFormula);
    }
    //از نوع محاسباتی
    if (this.model.ElementKindCode === ElementKind.Computational && this.model.Id && model.ProportionalwithElementId) {
      _elementFormula.ElementPropertyId = model.Id;
      if (model.Coefficien && model.Coefficien > 0) {
        if (!model.ProportionalWorkEffect && model.CalcBaseId) _elementFormula.Formula = `MV_${model.CalcBaseId}*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.WithoutBase && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.FixedWork && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}/${model.EffectBaseAmount}*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.StandardWork && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}/S_MonthlyStandardWorks*${model.Coefficien}`;
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.CalendarWork && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}/S_MonthlycalendardWorks*${model.Coefficien}`;
      } else {
        ///بدون مبنا
        if (!model.ProportionalWorkEffect && model.CalcBaseId) _elementFormula.Formula = `MV_${model.CalcBaseId}`;
        ////متناسب با کردکرد و بدون مبنا
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.WithoutBase && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}`;
        ///مبتناسب با کردکرد و با مبنای ثابت
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.FixedWork && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}/${model.EffectBaseAmount}`;
        ///متنباسب با کار کرد و با مبنای کارکرد استاندارد
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.StandardWork && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}/S_MonthlyStandardWorks`;
        //متناسب با کارکرد و با مبنای کارکرد تقویمی
        if (model.ProportionalWorkEffect && model.EffectBaseCode === EffectBase.CalendarWork && model.CalcBaseId && model.ProportionalwithElementId)
          _elementFormula.Formula = `MV_${model.CalcBaseId}*MV_${model.ProportionalwithElementId}/S_MonthlycalendardWorks`;
      }

      if (model.CalcBaseId)
        PropertyInfo.push({ Title: model.CalcBaseTitle, key: `MV_${model.CalcBaseId}`, Formula: `MV_${model.CalcBaseId}`, items: [] });
      if (model.ProportionalwithElementId)
        PropertyInfo.push({
          Title: model.ProportionalwithElementTitle,
          key: `MV_${model.ProportionalwithElementId}`,
          Formula: `MV_${model.ProportionalwithElementId}`,
          items: [],
        });

      PropertyInfo.push({ Title: "کارکرد استاندارد", key: `S_MonthlyStandardWorks`, Formula: `S_MonthlyStandardWorks`, items: [] });
      PropertyInfo.push({ Title: "کارکرد تقویمی", key: `S_MonthlycalendardWorks`, Formula: `S_MonthlycalendardWorks`, items: [] });

      _elementFormula.PropertyInfo = JSON.stringify(PropertyInfo);
      model.ElementFormulas = [];
      model.ElementFormulas.push(_elementFormula);
    }
  }
}
